import {IEventData} from 'coreClasses/events/IEvents';
import ManagerRepository from 'coreClasses/ManagerRepository';

import EventModel from '../EventModel';
import WishlistInfoModel from './models/WishlistInfoModel';

/**
 * Represents WishlistUpdatedEventModel
 */
export default class WishlistUpdatedEventModel extends EventModel {
	public event: string;
	public wishlistInfo: WishlistInfoModel;

	/**
	 * @constructor
	 * @param {ManagerRepository} managerRepository - ManagerRepository instance
	 * @param {IEventData} data - data
	 */
	constructor(managerRepository: ManagerRepository, data: IEventData) {
		super(managerRepository, data);

		const wishlist = data.wishlist;

		this.event = data.event;
		this.wishlistInfo = {...new WishlistInfoModel(managerRepository, wishlist)};
	}

	/**
	 * Checks if event is persistent
	 * @returns {boolean} true if event is persistent
	 */
	public isPersistentEvent() {
		return false;
	}
}
